import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=1afb71d5&scoped=true&"
import script from "./Credits.vue?vue&type=script&lang=ts&"
export * from "./Credits.vue?vue&type=script&lang=ts&"
import style0 from "./Credits.vue?vue&type=style&index=0&id=1afb71d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb71d5",
  null
  
)

export default component.exports